import { createElement as h } from "react"

import { CssBaseline } from "@mui/material"
import {
  createGenerateClassName,
  jssPreset,
  makeStyles,
  StylesProvider as MuiStylesProvider,
} from "@mui/styles"
import { create } from "jss"
import extendPlugin from "jss-plugin-extend"
import templatePlugin from "jss-plugin-template"
import { concat } from "ramda"
import { cx } from "ramda-extension/es"

import "../assets/icomoon.css"
import { UIParams } from "../_params"

const jss = create({ plugins: concat(jssPreset().plugins, [extendPlugin(), templatePlugin()]) }),
  generateClassName = createGenerateClassName({ productionPrefix: "cirrus", seed: "cirrus" })

const useStaticOverrides = makeStyles(UIParams.blocks),
  useDynamicOverrides = makeStyles(({ cssVariables }) => ({ ":root": cssVariables }))

export const StylesProvider = ({ children }) =>
  h(
    MuiStylesProvider,
    { generateClassName, jss },
    h(CssBaseline, { classes: cx(useStaticOverrides(), useDynamicOverrides()) }),
    children,
  )
